module.exports = __webpack_public_path__ + "img/6.e52a347e.png";